/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-console */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useAuthContext } from "../../context/auth";
import { getEdificios } from "../../utils";
import "./stylesCotizadorProgrammaticInventario.scss";

export const CotizadorProgrammaticInventario = ({
  onSubmit,
  isProgrammaticSelected,
  resetInventario,
  onResetComplete,
  includeInstallingBuildings,
  defaultEdificios,
  defaultEdificiosAscensores,
  defaultEdificiosTotems,
  defaultEdificiosEspera,
  defaultEdificiosCowork,
}) => {
  const [, setAudienciaSeleccionadaTotal] = useState(0);
  const [ascensoresSeleccionados, setAscensoresSeleccionados] = useState(0);
  const [audienciaSeleccionadaAscensor, setAudienciaSeleccionadaAscensor] = useState(0);
  const [audienciaSeleccionadaCowork, setAudienciaSeleccionadaCowork] = useState(0);
  const [audienciaSeleccionadaEspera, setAudienciaSeleccionadaEspera] = useState(0);
  const [audienciaSeleccionadaTotems, setAudienciaSeleccionadaTotems] = useState(0);
  const [coworkSeleccionados, setCoworkSeleccionados] = useState(0);
  const [edificios, setEdificios] = useState([]);
  const [edificiosSeleccionadosAscensores, setEdificiosSeleccionadosAscensores] = useState(
    new Set(defaultEdificiosAscensores ? defaultEdificiosAscensores.map(String) : [])
  );
  const [edificiosSeleccionadosTotems, setEdificiosSeleccionadosTotems] = useState(
    new Set(defaultEdificiosTotems ? defaultEdificiosTotems.map(String) : [])
  );
  const [edificiosSeleccionadosEspera, setEdificiosSeleccionadosEspera] = useState(
    new Set(defaultEdificiosEspera ? defaultEdificiosEspera.map(String) : [])
  );
  const [edificiosSeleccionadosCowork, setEdificiosSeleccionadosCowork] = useState(
    new Set(defaultEdificiosCowork ? defaultEdificiosCowork.map(String) : [])
  );
  const [esperaSeleccionados, setEsperaSeleccionados] = useState(0);
  const [totemsSeleccionados, setTotemsSeleccionados] = useState(0);
  const [pantallasPorUbicacionMap, setPantallasPorUbicacionMap] = useState({});
  const [selectAllAscensores, setSelectAllAscensores] = useState(false);
  const [selectAllCowork, setSelectAllCowork] = useState(false);
  const [selectAllEspera, setSelectAllEspera] = useState(false);
  const [selectAllNetwork, setSelectAllNetwork] = useState(false);
  const [selectAllTotems, setSelectAllTotems] = useState(false);
  const [selectInventory, setSelectInventory] = useState(
    defaultEdificiosAscensores?.length > 0 ||
      defaultEdificiosTotems?.length > 0 ||
      defaultEdificiosEspera?.length > 0 ||
      defaultEdificiosCowork?.length > 0
  );
  const [ubicaciones, setUbicaciones] = useState([]);
  const [ubicacionesSeleccionadas, setUbicacionesSeleccionadas] = useState(new Set());
  const initialValuesRef = useRef({
    ascensoresSeleccionados: 0,
    audienciaSeleccionadaAscensor: 0,
    coworkSeleccionados: 0,
    audienciaSeleccionadaCowork: 0,
    totemsSeleccionados: 0,
    audienciaSeleccionadaTotems: 0,
    esperaSeleccionados: 0,
    audienciaSeleccionadaEspera: 0,
    edificiosSeleccionadosCowork: [],
  });
  const hasInitializedRef = useRef(false);

  const { pais, rol } = useAuthContext();

  const isInitialSyncRef = useRef(true);

  const syncPayload = () => {
    const totalAudiencia = calculateTotalAudience(
      edificiosSeleccionadosAscensores,
      edificiosSeleccionadosTotems,
      edificiosSeleccionadosEspera,
      edificiosSeleccionadosCowork
    );
    setAudienciaSeleccionadaTotal(totalAudiencia);

    const payload = {
      ascensoresSeleccionados,
      audienciaSeleccionadaAscensor,
      audienciaSeleccionadaCowork,
      audienciaSeleccionadaTotems,
      audienciaSeleccionadaEspera,
      coworkSeleccionados,
      esperaSeleccionados,
      audienciaSeleccionadaTotal: totalAudiencia,
      edificiosSeleccionadosAscensores: [...edificiosSeleccionadosAscensores],
      edificiosSeleccionadosTotems: [...edificiosSeleccionadosTotems],
      edificiosSeleccionadosCowork: [...edificiosSeleccionadosCowork],
      edificiosSeleccionadosEspera: [...edificiosSeleccionadosEspera],
      totemsSeleccionados, // Usar el estado totemsSeleccionados
    };
    onSubmit(payload);
  };

  useEffect(() => {
    if (hasInitializedRef.current) return;
    const initialize = async () => {
      // Cargar edificios
      let newEdificios = await getEdificios({ pais });
      // Excluir edificios con ID 119 y 121
      newEdificios = newEdificios.filter((edificio) => edificio.id !== 119 && edificio.id !== 121);
      // Aplicar filtros basados en rol y includeInstallingBuildings
      if (rol !== "superadmin") {
        newEdificios = includeInstallingBuildings
          ? newEdificios.filter((edificio) => ["OPERATIVO", "INSTALACIÓN", "REACTIVACIÓN"].includes(edificio.estado))
          : newEdificios.filter((edificio) => edificio.estado === "OPERATIVO");
      } else {
        if (!includeInstallingBuildings) {
          newEdificios = newEdificios.filter((edificio) => edificio.estado === "OPERATIVO");
        }
      }
      // Filtrar por is_programmatic si aplica
      if (isProgrammaticSelected) {
        newEdificios = newEdificios.filter((edificio) => edificio.is_programmatic === true);
      }
      // Ordenar edificios
      newEdificios.sort((a, b) => {
        if (a.edificio && b.edificio) {
          return a.edificio.localeCompare(b.edificio);
        }
        return 0;
      });
      const uniqueUbicaciones = [...new Set(newEdificios.map((edificio) => edificio.ubicacion))];
      const pantallasMap = {};
      uniqueUbicaciones.forEach((ubicacion) => {
        pantallasMap[ubicacion] = newEdificios.reduce(
          (suma, edificio) =>
            edificio.ubicacion === ubicacion
              ? suma +
                (edificio.pantallas || 0) +
                (edificio.totems || 0) +
                (edificio.cowork || 0) +
                (edificio.espera || 0)
              : suma,
          0
        );
      });
      // Calcular cantidades y audiencias iniciales basadas en los edificios seleccionados por tipo
      let initialAscensores = 0;
      let initialTotems = 0;
      let initialCowork = 0;
      let initialEspera = 0;
      let initialAudienciaAscensor = 0;
      let initialAudienciaTotems = 0;
      let initialAudienciaCowork = 0;
      let initialAudienciaEspera = 0;
      let selectAllNetworkValue = false;
      let selectInventoryValue =
        defaultEdificiosAscensores?.length > 0 ||
        defaultEdificiosTotems?.length > 0 ||
        defaultEdificiosEspera?.length > 0 ||
        defaultEdificiosCowork?.length > 0;
      if (
        defaultEdificiosAscensores?.length > 0 ||
        defaultEdificiosTotems?.length > 0 ||
        defaultEdificiosEspera?.length > 0 ||
        defaultEdificiosCowork?.length > 0
      ) {
        const allEdificiosIds = new Set(newEdificios.map((e) => String(e.id)));
        const selectedEdificiosSet = new Set(
          [
            ...(defaultEdificiosAscensores || []),
            ...(defaultEdificiosTotems || []),
            ...(defaultEdificiosEspera || []),
            ...(defaultEdificiosCowork || []),
          ].map(String)
        );
        const isAllSelected = [...allEdificiosIds].every((id) => selectedEdificiosSet.has(id));
        if (isAllSelected) {
          selectAllNetworkValue = true;
          selectInventoryValue = false;
        }
        // Calcular cantidades y audiencias para ascensores
        (defaultEdificiosAscensores || []).forEach((id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          if (edificio) {
            initialAscensores += edificio.pantallas || 0;
            initialAudienciaAscensor += edificio.personas || 0;
          }
        });
        // Calcular cantidades y audiencias para totems
        (defaultEdificiosTotems || []).forEach((id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          if (edificio) {
            initialTotems += edificio.totems || 0;
            initialAudienciaTotems += edificio.personas || 0;
          }
        });
        // Calcular cantidades y audiencias para espera
        (defaultEdificiosEspera || []).forEach((id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          if (edificio) {
            initialEspera += edificio.espera || 0;
            initialAudienciaEspera += edificio.personas || 0;
          }
        });
        // Calcular cantidades y audiencias para cowork
        (defaultEdificiosCowork || []).forEach((id) => {
          const edificio = newEdificios.find((e) => String(e.id) === String(id));
          if (edificio) {
            initialCowork += edificio.cowork || 0;
            initialAudienciaCowork += edificio.personas || 0;
          }
        });
      }
      // Establecer todos los estados de una vez
      setUbicaciones(uniqueUbicaciones);
      setPantallasPorUbicacionMap(pantallasMap);
      setEdificios(newEdificios);
      setAscensoresSeleccionados(initialAscensores);
      setTotemsSeleccionados(initialTotems);
      setCoworkSeleccionados(initialCowork);
      setEsperaSeleccionados(initialEspera);
      setAudienciaSeleccionadaAscensor(initialAudienciaAscensor);
      setAudienciaSeleccionadaTotems(initialAudienciaTotems);
      setAudienciaSeleccionadaCowork(initialAudienciaCowork);
      setAudienciaSeleccionadaEspera(initialAudienciaEspera);
      setSelectAllNetwork(selectAllNetworkValue);
      setSelectInventory(selectInventoryValue);
      initialValuesRef.current = {
        ascensoresSeleccionados: initialAscensores,
        audienciaSeleccionadaAscensor: initialAudienciaAscensor,
        coworkSeleccionados: initialCowork,
        audienciaSeleccionadaCowork: initialAudienciaCowork,
        totemsSeleccionados: initialTotems,
        audienciaSeleccionadaTotems: initialAudienciaTotems,
        esperaSeleccionados: initialEspera,
        audienciaSeleccionadaEspera: initialAudienciaEspera,
        edificiosSeleccionadosCowork: [...(defaultEdificiosCowork || [])],
      };
      // Calcular la audiencia total inicial usando un conjunto único de IDs
      const uniqueInitialEdificioIds = new Set(
        [
          ...(defaultEdificiosAscensores || []),
          ...(defaultEdificiosTotems || []),
          ...(defaultEdificiosEspera || []),
          ...(defaultEdificiosCowork || []),
        ].map(String)
      );
      const totalAudiencia = [...uniqueInitialEdificioIds].reduce((total, id) => {
        const edificio = newEdificios.find((e) => String(e.id) === String(id));
        return edificio ? total + (edificio.personas || 0) : total;
      }, 0);
      setAudienciaSeleccionadaTotal(totalAudiencia);
      const payload = {
        ascensoresSeleccionados: initialAscensores,
        audienciaSeleccionadaAscensor: initialAudienciaAscensor,
        audienciaSeleccionadaCowork: initialAudienciaCowork,
        audienciaSeleccionadaTotems: initialAudienciaTotems,
        audienciaSeleccionadaEspera: initialAudienciaEspera,
        coworkSeleccionados: initialCowork,
        esperaSeleccionados: initialEspera,
        audienciaSeleccionadaTotal: totalAudiencia,
        edificiosSeleccionadosAscensores: [...(defaultEdificiosAscensores || [])],
        edificiosSeleccionadosTotems: [...(defaultEdificiosTotems || [])],
        edificiosSeleccionadosCowork: [...(defaultEdificiosCowork || [])],
        edificiosSeleccionadosEspera: [...(defaultEdificiosEspera || [])],
        totemsSeleccionados: initialTotems,
      };
      onSubmit(payload);
      // Si no hay edificios seleccionados, enviamos un payload vacío
      if (
        (!defaultEdificiosAscensores || defaultEdificiosAscensores.length === 0) &&
        (!defaultEdificiosTotems || defaultEdificiosTotems.length === 0) &&
        (!defaultEdificiosEspera || defaultEdificiosEspera.length === 0) &&
        (!defaultEdificiosCowork || defaultEdificiosCowork.length === 0)
      ) {
        const emptyPayload = {
          ascensoresSeleccionados: 0,
          audienciaSeleccionadaAscensor: 0,
          audienciaSeleccionadaCowork: 0,
          audienciaSeleccionadaTotems: 0,
          audienciaSeleccionadaEspera: 0,
          coworkSeleccionados: 0,
          esperaSeleccionados: 0,
          audienciaSeleccionadaTotal: 0,
          edificiosSeleccionadosAscensores: [],
          edificiosSeleccionadosTotems: [],
          edificiosSeleccionadosCowork: [],
          edificiosSeleccionadosEspera: [],
          totemsSeleccionados: 0,
        };
        onSubmit(emptyPayload);
        setAudienciaSeleccionadaTotal(0);
      }
      hasInitializedRef.current = true;
      isInitialSyncRef.current = false;
    };
    initialize();
  }, [
    pais,
    rol,
    isProgrammaticSelected,
    includeInstallingBuildings,
    defaultEdificiosAscensores,
    defaultEdificiosTotems,
    defaultEdificiosEspera,
    defaultEdificiosCowork,
  ]);

  useEffect(() => {
    if (isInitialSyncRef.current) return; // Evitamos que se ejecute durante la sincronización inicial

    syncPayload();
  }, [
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosEspera,
    edificiosSeleccionadosCowork,
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    audienciaSeleccionadaAscensor,
    audienciaSeleccionadaTotems,
    audienciaSeleccionadaCowork,
    audienciaSeleccionadaEspera,
  ]);

  useEffect(() => {
    if (resetInventario) {
      isInitialSyncRef.current = true; // Evitar syncPayload durante reset
      const resetAndReload = async () => {
        try {
          // Cargar edificios con el filtro correcto
          let newEdificios = await getEdificios({ pais });
          // Excluir edificios con ID 119 y 121
          newEdificios = newEdificios.filter((edificio) => edificio.id !== 119 && edificio.id !== 121);
          // Aplicar filtro basado en includeInstallingBuildings y rol
          if (rol !== "superadmin") {
            newEdificios = includeInstallingBuildings
              ? newEdificios.filter((edificio) =>
                  ["OPERATIVO", "INSTALACIÓN", "REACTIVACIÓN"].includes(edificio.estado)
                )
              : newEdificios.filter((edificio) => edificio.estado === "OPERATIVO");
          } else {
            newEdificios = includeInstallingBuildings
              ? newEdificios
              : newEdificios.filter((edificio) => edificio.estado === "OPERATIVO");
          }
          // Filtrar por is_programmatic si aplica
          if (isProgrammaticSelected) {
            newEdificios = newEdificios.filter((edificio) => edificio.is_programmatic === true);
          }
          // Ordenar edificios
          newEdificios.sort((a, b) => {
            if (a.edificio && b.edificio) {
              return a.edificio.localeCompare(b.edificio);
            }
            return 0;
          });
          // Actualizar estado de edificios
          setEdificios(newEdificios);
          // Restablecer todos los estados
          setAscensoresSeleccionados(0);
          setTotemsSeleccionados(0);
          setCoworkSeleccionados(0);
          setEsperaSeleccionados(0);
          setAudienciaSeleccionadaAscensor(0);
          setAudienciaSeleccionadaTotems(0);
          setAudienciaSeleccionadaCowork(0);
          setAudienciaSeleccionadaEspera(0);
          setEdificiosSeleccionadosAscensores(new Set());
          setEdificiosSeleccionadosTotems(new Set());
          setEdificiosSeleccionadosCowork(new Set());
          setEdificiosSeleccionadosEspera(new Set());
          setSelectAllAscensores(false);
          setSelectAllTotems(false);
          setSelectAllCowork(false);
          setSelectAllEspera(false);
          setSelectAllNetwork(false);
          setSelectInventory(false);
          setUbicacionesSeleccionadas(new Set());
          // Actualizar ubicaciones y pantallas por ubicación
          const uniqueUbicaciones = [...new Set(newEdificios.map((edificio) => edificio.ubicacion))];
          const pantallasMap = {};
          uniqueUbicaciones.forEach((ubicacion) => {
            pantallasMap[ubicacion] = newEdificios.reduce(
              (suma, edificio) =>
                edificio.ubicacion === ubicacion
                  ? suma +
                    (edificio.pantallas || 0) +
                    (edificio.totems || 0) +
                    (edificio.cowork || 0) +
                    (edificio.espera || 0)
                  : suma,
              0
            );
          });
          setUbicaciones(uniqueUbicaciones);
          setPantallasPorUbicacionMap(pantallasMap);
          // Calcular audiencia total
          const totalAudiencia = calculateTotalAudience();
          setAudienciaSeleccionadaTotal(totalAudiencia);
          // Enviar payload vacío
          const payload = {
            ascensoresSeleccionados: 0,
            audienciaSeleccionadaAscensor: 0,
            audienciaSeleccionadaCowork: 0,
            audienciaSeleccionadaTotems: 0,
            audienciaSeleccionadaEspera: 0,
            coworkSeleccionados: 0,
            esperaSeleccionados: 0,
            audienciaSeleccionadaTotal: totalAudiencia,
            edificiosSeleccionadosAscensores: [],
            edificiosSeleccionadosTotems: [],
            edificiosSeleccionadosCowork: [],
            edificiosSeleccionadosEspera: [],
            totemsSeleccionados: 0,
          };
          onSubmit(payload);
        } catch (error) {
          console.error("Error al resetear inventario:", error);
        } finally {
          isInitialSyncRef.current = false;
          onResetComplete();
        }
      };
      resetAndReload();
    }
  }, [resetInventario, pais, rol, isProgrammaticSelected, includeInstallingBuildings, onResetComplete, onSubmit]);

  const calculateTotalAudience = useCallback(
    (
      ascensoresSet = edificiosSeleccionadosAscensores,
      totemsSet = edificiosSeleccionadosTotems,
      esperaSet = edificiosSeleccionadosEspera,
      coworkSet = edificiosSeleccionadosCowork
    ) => {
      // Crear un conjunto único de IDs de edificios seleccionados
      const uniqueEdificioIds = new Set([...ascensoresSet, ...totemsSet, ...esperaSet, ...coworkSet]);

      // Calcular la audiencia total sumando solo una vez por edificio
      const totalAudiencia = [...uniqueEdificioIds].reduce((total, id) => {
        const edificio = edificios.find((e) => String(e.id) === String(id));
        return edificio ? total + (edificio.personas || 0) : total;
      }, 0);

      return totalAudiencia;
    },
    [edificios]
  );

  const handleCheckboxChange = (pantallas, isChecked, tipo, personas, id) => {
    if (selectAllNetwork) return;

    const edificio = edificios.find((e) => String(e.id) === String(id));
    if (!edificio) return;

    const isSelectedByLocation = ubicacionesSeleccionadas.has(edificio.ubicacion);
    if (isSelectedByLocation) return;

    const idAsString = String(id);

    let updatedAscensores = ascensoresSeleccionados;
    let updatedTotems = totemsSeleccionados;
    let updatedCowork = coworkSeleccionados;
    let updatedEspera = esperaSeleccionados;

    const newEdificiosSeleccionadosAscensores = new Set(edificiosSeleccionadosAscensores);
    const newEdificiosSeleccionadosTotems = new Set(edificiosSeleccionadosTotems);
    const newEdificiosSeleccionadosCowork = new Set(edificiosSeleccionadosCowork);
    const newEdificiosSeleccionadosEspera = new Set(edificiosSeleccionadosEspera);

    if (tipo === "edificios") {
      if (isChecked) {
        if (edificio.pantallas > 0) {
          newEdificiosSeleccionadosAscensores.add(idAsString);
          updatedAscensores += edificio.pantallas;
        }
        if (edificio.totems > 0) {
          newEdificiosSeleccionadosTotems.add(idAsString);
          updatedTotems += edificio.totems;
        }
        if (edificio.cowork > 0) {
          newEdificiosSeleccionadosCowork.add(idAsString);
          updatedCowork += edificio.cowork;
        }
        if (edificio.espera > 0) {
          newEdificiosSeleccionadosEspera.add(idAsString);
          updatedEspera += edificio.espera;
        }
      } else {
        if (edificio.pantallas > 0) {
          newEdificiosSeleccionadosAscensores.delete(idAsString);
          updatedAscensores -= edificio.pantallas;
        }
        if (edificio.totems > 0) {
          newEdificiosSeleccionadosTotems.delete(idAsString);
          updatedTotems -= edificio.totems;
        }
        if (edificio.cowork > 0) {
          newEdificiosSeleccionadosCowork.delete(idAsString);
          updatedCowork -= edificio.cowork;
        }
        if (edificio.espera > 0) {
          newEdificiosSeleccionadosEspera.delete(idAsString);
          updatedEspera -= edificio.espera;
        }
      }
    } else if (tipo === "ascensores") {
      const wasSelected = newEdificiosSeleccionadosAscensores.has(idAsString);
      if (isChecked && !wasSelected && edificio.pantallas > 0) {
        newEdificiosSeleccionadosAscensores.add(idAsString);
        updatedAscensores += pantallas;
      } else if (!isChecked && wasSelected && edificio.pantallas > 0) {
        newEdificiosSeleccionadosAscensores.delete(idAsString);
        updatedAscensores -= pantallas;
      }
    } else if (tipo === "totems") {
      const wasSelected = newEdificiosSeleccionadosTotems.has(idAsString);
      if (isChecked && !wasSelected && edificio.totems > 0) {
        newEdificiosSeleccionadosTotems.add(idAsString);
        updatedTotems += pantallas;
      } else if (!isChecked && wasSelected && edificio.totems > 0) {
        newEdificiosSeleccionadosTotems.delete(idAsString);
        updatedTotems -= pantallas;
      }
    } else if (tipo === "cowork") {
      const wasSelected = newEdificiosSeleccionadosCowork.has(idAsString);
      if (isChecked && !wasSelected && edificio.cowork > 0) {
        newEdificiosSeleccionadosCowork.add(idAsString);
        updatedCowork += pantallas;
      } else if (!isChecked && wasSelected && edificio.cowork > 0) {
        newEdificiosSeleccionadosCowork.delete(idAsString);
        updatedCowork -= pantallas;
      }
    } else if (tipo === "espera") {
      const wasSelected = newEdificiosSeleccionadosEspera.has(idAsString);
      if (isChecked && !wasSelected && edificio.espera > 0) {
        newEdificiosSeleccionadosEspera.add(idAsString);
        updatedEspera += pantallas;
      } else if (!isChecked && wasSelected && edificio.espera > 0) {
        newEdificiosSeleccionadosEspera.delete(idAsString);
        updatedEspera -= pantallas;
      }
    }

    updatedAscensores = Math.max(updatedAscensores, 0);
    updatedTotems = Math.max(updatedTotems, 0);
    updatedCowork = Math.max(updatedCowork, 0);
    updatedEspera = Math.max(updatedEspera, 0);

    setEdificiosSeleccionadosAscensores(newEdificiosSeleccionadosAscensores);
    setEdificiosSeleccionadosTotems(newEdificiosSeleccionadosTotems);
    setEdificiosSeleccionadosCowork(newEdificiosSeleccionadosCowork);
    setEdificiosSeleccionadosEspera(newEdificiosSeleccionadosEspera);
    setAscensoresSeleccionados(updatedAscensores);
    setTotemsSeleccionados(updatedTotems);
    setCoworkSeleccionados(updatedCowork);
    setEsperaSeleccionados(updatedEspera);

    const updatedAudienciaAscensor = [...newEdificiosSeleccionadosAscensores].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.pantallas > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaTotems = [...newEdificiosSeleccionadosTotems].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.totems > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaCowork = [...newEdificiosSeleccionadosCowork].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.cowork > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaEspera = [...newEdificiosSeleccionadosEspera].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.espera > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    setAudienciaSeleccionadaAscensor(updatedAudienciaAscensor);
    setAudienciaSeleccionadaTotems(updatedAudienciaTotems);
    setAudienciaSeleccionadaCowork(updatedAudienciaCowork);
    setAudienciaSeleccionadaEspera(updatedAudienciaEspera);

    const totalAudiencia = calculateTotalAudience(
      newEdificiosSeleccionadosAscensores,
      newEdificiosSeleccionadosTotems,
      newEdificiosSeleccionadosEspera,
      newEdificiosSeleccionadosCowork
    );
    setAudienciaSeleccionadaTotal(totalAudiencia);

    const payload = {
      ascensoresSeleccionados: updatedAscensores,
      audienciaSeleccionadaAscensor: updatedAudienciaAscensor,
      audienciaSeleccionadaCowork: updatedAudienciaCowork,
      audienciaSeleccionadaTotems: updatedAudienciaTotems,
      audienciaSeleccionadaEspera: updatedAudienciaEspera,
      coworkSeleccionados: updatedCowork,
      esperaSeleccionados: updatedEspera,
      audienciaSeleccionadaTotal: totalAudiencia,
      edificiosSeleccionadosAscensores: [...newEdificiosSeleccionadosAscensores],
      edificiosSeleccionadosTotems: [...newEdificiosSeleccionadosTotems],
      edificiosSeleccionadosCowork: [...newEdificiosSeleccionadosCowork],
      edificiosSeleccionadosEspera: [...newEdificiosSeleccionadosEspera],
      totemsSeleccionados: updatedTotems,
    };
    onSubmit(payload);
  };

  function sumarPantallas(edificios) {
    return edificios.reduce((total, edificio) => total + (edificio.pantallas || 0), 0);
  }

  function sumarTotems(edificios) {
    return edificios.reduce((total, edificio) => total + (edificio.totems || 0), 0);
  }

  function sumarCowork(edificios) {
    return edificios.reduce((total, edificio) => total + (edificio.cowork || 0), 0);
  }

  function sumarEspera(edificios) {
    return edificios.reduce((total, edificio) => total + (edificio.espera || 0), 0);
  }

  function sumarTotalPantallas(edificio) {
    return (edificio.pantallas || 0) + (edificio.totems || 0) + (edificio.cowork || 0) + (edificio.espera || 0);
  }

  const handleSelectAllChange = (isChecked, tipo, ubicacion = null) => {
    const resetState = () => {
      setEdificiosSeleccionadosAscensores(new Set());
      setEdificiosSeleccionadosTotems(new Set());
      setEdificiosSeleccionadosCowork(new Set());
      setEdificiosSeleccionadosEspera(new Set());
      setAscensoresSeleccionados(0);
      setTotemsSeleccionados(0);
      setCoworkSeleccionados(0);
      setEsperaSeleccionados(0);
      setAudienciaSeleccionadaAscensor(0);
      setAudienciaSeleccionadaTotems(0);
      setAudienciaSeleccionadaCowork(0);
      setAudienciaSeleccionadaEspera(0);
      setSelectAllAscensores(false);
      setSelectAllTotems(false);
      setSelectAllCowork(false);
      setSelectAllEspera(false);
      setUbicacionesSeleccionadas(new Set());
    };

    let updatedAscensores = ascensoresSeleccionados;
    let updatedTotems = totemsSeleccionados;
    let updatedCowork = coworkSeleccionados;
    let updatedEspera = esperaSeleccionados;

    let updatedEdificiosSeleccionadosAscensores = new Set(edificiosSeleccionadosAscensores);
    let updatedEdificiosSeleccionadosTotems = new Set(edificiosSeleccionadosTotems);
    let updatedEdificiosSeleccionadosCowork = new Set(edificiosSeleccionadosCowork);
    let updatedEdificiosSeleccionadosEspera = new Set(edificiosSeleccionadosEspera);

    if (tipo === "network") {
      resetState();
      setSelectAllNetwork(isChecked);
      setSelectInventory(false);

      if (isChecked) {
        updatedEdificiosSeleccionadosAscensores = new Set(
          edificios.filter((e) => e.pantallas > 0).map((e) => String(e.id))
        );
        updatedEdificiosSeleccionadosTotems = new Set(edificios.filter((e) => e.totems > 0).map((e) => String(e.id)));
        updatedEdificiosSeleccionadosCowork = new Set(edificios.filter((e) => e.cowork > 0).map((e) => String(e.id)));
        updatedEdificiosSeleccionadosEspera = new Set(edificios.filter((e) => e.espera > 0).map((e) => String(e.id)));

        updatedAscensores = sumarPantallas(edificios);
        updatedTotems = sumarTotems(edificios);
        updatedCowork = sumarCowork(edificios);
        updatedEspera = sumarEspera(edificios);
      } else {
        updatedEdificiosSeleccionadosAscensores = new Set();
        updatedEdificiosSeleccionadosTotems = new Set();
        updatedEdificiosSeleccionadosCowork = new Set();
        updatedEdificiosSeleccionadosEspera = new Set();
        updatedAscensores = 0;
        updatedTotems = 0;
        updatedCowork = 0;
        updatedEspera = 0;
      }
    } else if (tipo === "inventory") {
      resetState();
      setSelectInventory(isChecked);
      setSelectAllNetwork(false);
    } else if (selectInventory) {
      if (tipo === "ubicacion" && ubicacion) {
        if (isChecked) {
          setUbicacionesSeleccionadas((prev) => new Set([...prev, ubicacion]));
          const edificiosDeUbicacion = edificios.filter((edificio) => edificio.ubicacion === ubicacion);
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            if (edificio.pantallas > 0) {
              updatedEdificiosSeleccionadosAscensores.add(idAsString);
              updatedAscensores += edificio.pantallas;
            }
            if (edificio.totems > 0) {
              updatedEdificiosSeleccionadosTotems.add(idAsString);
              updatedTotems += edificio.totems;
            }
            if (edificio.cowork > 0) {
              updatedEdificiosSeleccionadosCowork.add(idAsString);
              updatedCowork += edificio.cowork;
            }
            if (edificio.espera > 0) {
              updatedEdificiosSeleccionadosEspera.add(idAsString);
              updatedEspera += edificio.espera;
            }
          });
        } else {
          setUbicacionesSeleccionadas((prev) => {
            const newSet = new Set(prev);
            newSet.delete(ubicacion);
            return newSet;
          });
          const edificiosDeUbicacion = edificios.filter((edificio) => edificio.ubicacion === ubicacion);
          edificiosDeUbicacion.forEach((edificio) => {
            const idAsString = String(edificio.id);
            if (edificio.pantallas > 0) {
              updatedEdificiosSeleccionadosAscensores.delete(idAsString);
              updatedAscensores = Math.max(updatedAscensores - edificio.pantallas, 0);
            }
            if (edificio.totems > 0) {
              updatedEdificiosSeleccionadosTotems.delete(idAsString);
              updatedTotems = Math.max(updatedTotems - edificio.totems, 0);
            }
            if (edificio.cowork > 0) {
              updatedEdificiosSeleccionadosCowork.delete(idAsString);
              updatedCowork = Math.max(updatedCowork - edificio.cowork, 0);
            }
            if (edificio.espera > 0) {
              updatedEdificiosSeleccionadosEspera.delete(idAsString);
              updatedEspera = Math.max(updatedEspera - edificio.espera, 0);
            }
          });
        }
      } else if (tipo === "ascensores") {
        if (isChecked) {
          const buildingsToAdd = edificios.filter(
            (edificio) => edificio.pantallas > 0 && !updatedEdificiosSeleccionadosAscensores.has(String(edificio.id))
          );
          buildingsToAdd.forEach((edificio) => {
            updatedEdificiosSeleccionadosAscensores.add(String(edificio.id));
          });
          updatedAscensores = sumarPantallas(edificios);
        } else {
          updatedEdificiosSeleccionadosAscensores = new Set();
          updatedAscensores = 0;
        }
        setSelectAllAscensores(isChecked);
      } else if (tipo === "totems") {
        if (isChecked) {
          const buildingsToAdd = edificios.filter(
            (edificio) => edificio.totems > 0 && !updatedEdificiosSeleccionadosTotems.has(String(edificio.id))
          );
          buildingsToAdd.forEach((edificio) => {
            updatedEdificiosSeleccionadosTotems.add(String(edificio.id));
          });
          updatedTotems = sumarTotems(edificios);
        } else {
          updatedEdificiosSeleccionadosTotems = new Set();
          updatedTotems = 0;
        }
        setSelectAllTotems(isChecked);
      } else if (tipo === "cowork") {
        if (isChecked) {
          const buildingsToAdd = edificios.filter(
            (edificio) => edificio.cowork > 0 && !updatedEdificiosSeleccionadosCowork.has(String(edificio.id))
          );
          buildingsToAdd.forEach((edificio) => {
            updatedEdificiosSeleccionadosCowork.add(String(edificio.id));
          });
          updatedCowork = sumarCowork(edificios);
        } else {
          updatedEdificiosSeleccionadosCowork = new Set();
          updatedCowork = 0;
        }
        setSelectAllCowork(isChecked);
      } else if (tipo === "espera") {
        if (isChecked) {
          const buildingsToAdd = edificios.filter(
            (edificio) => edificio.espera > 0 && !updatedEdificiosSeleccionadosEspera.has(String(edificio.id))
          );
          buildingsToAdd.forEach((edificio) => {
            updatedEdificiosSeleccionadosEspera.add(String(edificio.id));
          });
          updatedEspera = sumarEspera(edificios);
        } else {
          updatedEdificiosSeleccionadosEspera = new Set();
          updatedEspera = 0;
        }
        setSelectAllEspera(isChecked);
      }
    }

    setEdificiosSeleccionadosAscensores(updatedEdificiosSeleccionadosAscensores);
    setEdificiosSeleccionadosTotems(updatedEdificiosSeleccionadosTotems);
    setEdificiosSeleccionadosCowork(updatedEdificiosSeleccionadosCowork);
    setEdificiosSeleccionadosEspera(updatedEdificiosSeleccionadosEspera);
    setAscensoresSeleccionados(updatedAscensores);
    setTotemsSeleccionados(updatedTotems);
    setCoworkSeleccionados(updatedCowork);
    setEsperaSeleccionados(updatedEspera);

    const updatedAudienciaAscensor = [...updatedEdificiosSeleccionadosAscensores].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.pantallas > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaTotems = [...updatedEdificiosSeleccionadosTotems].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.totems > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaCowork = [...updatedEdificiosSeleccionadosCowork].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.cowork > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    const updatedAudienciaEspera = [...updatedEdificiosSeleccionadosEspera].reduce((total, id) => {
      const edificio = edificios.find((e) => String(e.id) === String(id));
      return edificio && edificio.espera > 0 ? total + (edificio.personas || 0) : total;
    }, 0);

    setAudienciaSeleccionadaAscensor(updatedAudienciaAscensor);
    setAudienciaSeleccionadaTotems(updatedAudienciaTotems);
    setAudienciaSeleccionadaCowork(updatedAudienciaCowork);
    setAudienciaSeleccionadaEspera(updatedAudienciaEspera);

    const totalAudiencia = calculateTotalAudience(
      updatedEdificiosSeleccionadosAscensores,
      updatedEdificiosSeleccionadosTotems,
      updatedEdificiosSeleccionadosEspera,
      updatedEdificiosSeleccionadosCowork
    );
    setAudienciaSeleccionadaTotal(totalAudiencia);

    const payload = {
      ascensoresSeleccionados: updatedAscensores,
      audienciaSeleccionadaAscensor: updatedAudienciaAscensor,
      audienciaSeleccionadaCowork: updatedAudienciaCowork,
      audienciaSeleccionadaTotems: updatedAudienciaTotems,
      audienciaSeleccionadaEspera: updatedAudienciaEspera,
      coworkSeleccionados: updatedCowork,
      esperaSeleccionados: updatedEspera,
      audienciaSeleccionadaTotal: totalAudiencia,
      edificiosSeleccionadosAscensores: [...updatedEdificiosSeleccionadosAscensores],
      edificiosSeleccionadosTotems: [...updatedEdificiosSeleccionadosTotems],
      edificiosSeleccionadosCowork: [...updatedEdificiosSeleccionadosCowork],
      edificiosSeleccionadosEspera: [...updatedEdificiosSeleccionadosEspera],
      totemsSeleccionados: updatedTotems,
    };
    onSubmit(payload);
  };

  return (
    <div className="inventario">
      <p className="tituloinventario">INVENTARIO</p>
      <hr />

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={selectAllNetwork}
          onChange={(e) => handleSelectAllChange(e.target.checked, "network")}
          data-type="network"
        />
        <span>TODA LA RED</span>
      </div>

      <div className="seleccion">
        <input
          type="checkbox"
          className="cb123"
          checked={selectInventory}
          onChange={(e) => handleSelectAllChange(e.target.checked, "inventory")}
          data-type="inventory"
        />
        <span>SELECCIONAR</span>
      </div>
      <hr />

      {selectInventory && !selectAllNetwork && (
        <>
          <details>
            <summary className="subtitulo">EDIFICIOS</summary>
            <hr />
            {edificios.length > 0 && (
              <div>
                {edificios.map((edificio) => {
                  // Determinar cuántos tipos de pantallas tiene el edificio
                  const tiposDisponibles = [
                    edificio.pantallas > 0 ? "ascensores" : null,
                    edificio.totems > 0 ? "totems" : null,
                    edificio.cowork > 0 ? "cowork" : null,
                    edificio.espera > 0 ? "espera" : null,
                  ].filter(Boolean);

                  // Verificar si todos los tipos disponibles están seleccionados
                  const todosSeleccionados = tiposDisponibles.every((tipo) => {
                    if (tipo === "ascensores") return edificiosSeleccionadosAscensores.has(String(edificio.id));
                    if (tipo === "totems") return edificiosSeleccionadosTotems.has(String(edificio.id));
                    if (tipo === "cowork") return edificiosSeleccionadosCowork.has(String(edificio.id));
                    if (tipo === "espera") return edificiosSeleccionadosEspera.has(String(edificio.id));
                    return false;
                  });

                  return (
                    <div key={edificio.id} className="checkbox">
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px", marginRight: "10px" }}
                        checked={todosSeleccionados}
                        onChange={(e) =>
                          handleCheckboxChange(0, e.target.checked, "edificios", edificio.personas, edificio.id)
                        }
                        value={edificio.id}
                        data-type="edificios"
                      />
                      <span>
                        {sumarTotalPantallas(edificio)} | {edificio.edificio.toUpperCase()}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
            {edificios.length === 0 && <p>Cargando edificios...</p>}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">UBICACIÓN</summary>
            <hr />
            {ubicaciones.map((ubicacion, index) => (
              <div key={index} className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={ubicacionesSeleccionadas.has(ubicacion)}
                  onChange={(e) => handleSelectAllChange(e.target.checked, "ubicacion", ubicacion)}
                  data-type="ubicacion"
                />
                <span>
                  {pantallasPorUbicacionMap[ubicacion] || 0} | {ubicacion.toUpperCase()}
                </span>
              </div>
            ))}
          </details>
          <hr />

          <details>
            <summary className="subtitulo">ASCENSORES</summary>
            <hr />
            <div className="checkbox">
              <input
                type="checkbox"
                style={{ width: "15px", height: "15px", marginRight: "10px" }}
                checked={selectAllAscensores}
                onChange={(e) => {
                  const newCheckedState = !selectAllAscensores;
                  setSelectAllAscensores(newCheckedState);
                  handleSelectAllChange(newCheckedState, "ascensores");
                }}
              />
              <span style={{ fontWeight: "bold" }}>{sumarPantallas(edificios)} | SELECCIONAR TODOS</span>
            </div>
            {!selectAllAscensores && edificios.length > 0 && (
              <div>
                {edificios
                  .filter((edificio) => edificio.pantallas > 0)
                  .map((edificio) => (
                    <div key={edificio.id} className="checkbox">
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px", marginRight: "10px" }}
                        checked={edificiosSeleccionadosAscensores.has(String(edificio.id)) || selectAllAscensores}
                        onChange={(e) =>
                          handleCheckboxChange(
                            edificio.pantallas,
                            e.target.checked,
                            "ascensores",
                            edificio.personas,
                            edificio.id
                          )
                        }
                        value={edificio.id}
                        data-type="ascensores"
                      />
                      <span>
                        {edificio.pantallas} | {edificio.edificio.toUpperCase()}
                      </span>
                    </div>
                  ))}
              </div>
            )}
            {edificios.length === 0 && !selectAllAscensores && <p>Cargando edificios...</p>}
          </details>
          <hr />

          {edificios.some((edificio) => edificio.totems > 0) && (
            <details>
              <summary className="subtitulo">CIRCULACIÓN</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllTotems}
                  onChange={(e) => {
                    const newCheckedState = !selectAllTotems;
                    setSelectAllTotems(newCheckedState);
                    handleSelectAllChange(newCheckedState, "totems");
                  }}
                  data-type="totems"
                />
                <span style={{ fontWeight: "bold" }}>{sumarTotems(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllTotems && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.totems > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosTotems.has(String(edificio.id)) || selectAllTotems}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.totems,
                              e.target.checked,
                              "totems",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="totems"
                        />
                        <span>
                          {edificio.totems} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.espera > 0) && (
            <details>
              <summary className="subtitulo">ESPERA</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllEspera}
                  onChange={(e) => {
                    const newCheckedState = !selectAllEspera;
                    setSelectAllEspera(newCheckedState);
                    handleSelectAllChange(newCheckedState, "espera");
                  }}
                  data-type="espera"
                />
                <span style={{ fontWeight: "bold" }}>{sumarEspera(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllEspera && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.espera > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosEspera.has(String(edificio.id)) || selectAllEspera}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.espera,
                              e.target.checked,
                              "espera",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="espera"
                        />
                        <span>
                          {edificio.espera} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />

          {edificios.some((edificio) => edificio.cowork > 0) && (
            <details>
              <summary className="subtitulo">COWORK iF</summary>
              <hr />
              <div className="checkbox">
                <input
                  type="checkbox"
                  style={{ width: "15px", height: "15px", marginRight: "10px" }}
                  checked={selectAllCowork}
                  onChange={(e) => {
                    const newCheckedState = !selectAllCowork;
                    setSelectAllCowork(newCheckedState);
                    handleSelectAllChange(newCheckedState, "cowork");
                  }}
                  data-type="cowork"
                />
                <span style={{ fontWeight: "bold" }}>{sumarCowork(edificios)} | SELECCIONAR TODOS</span>
              </div>
              {!selectAllCowork && edificios.length > 0 && (
                <div>
                  {edificios
                    .filter((edificio) => edificio.cowork > 0)
                    .map((edificio) => (
                      <div key={edificio.id} className="checkbox">
                        <input
                          type="checkbox"
                          style={{ width: "15px", height: "15px", marginRight: "10px" }}
                          checked={edificiosSeleccionadosCowork.has(String(edificio.id)) || selectAllCowork}
                          onChange={(e) =>
                            handleCheckboxChange(
                              edificio.cowork,
                              e.target.checked,
                              "cowork",
                              edificio.personas,
                              edificio.id
                            )
                          }
                          value={edificio.id}
                          data-type="cowork"
                        />
                        <span>
                          {edificio.cowork} | {edificio.edificio.toUpperCase()}
                        </span>
                      </div>
                    ))}
                </div>
              )}
              <hr />
            </details>
          )}
          <hr />
        </>
      )}
    </div>
  );
};
